<script lang="ts" setup>
import BaseCard from "@/components/BaseCard.vue";
import CharacterSkillVotingSkill from "@/components/CharacterSkillVotingSkill.vue";
import { usePage } from "@inertiajs/vue3";
import axios from "axios";
import Swal from "sweetalert2";
import { defineProps, reactive } from "vue";
import { route } from "ziggy-js";

const props = defineProps<{
  character: Character;
  hasEza: boolean;
  hasSeza: boolean;
}>();

const page = usePage();
const skillVotes = reactive(props.character.skill_votes);

function vote(skillId: number) {
  if (!page.props.user?.verified) {
    Swal.fire({
      title: "Oops!",
      text: "You must be a verified member in order to vote.",
      icon: "error",
      toast: true,
      position: "bottom",
      timer: 3000,
      timerProgressBar: true,
      showConfirmButton: false,
    });

    return;
  }

  if (skillVotes.user === null) {
    skillVotes.total++;
  } else {
    skillVotes[skillVotes.user]--;
  }

  skillVotes.user = skillId;
  skillVotes[skillId]++;

  axios
    .post(
      route("characters.skill-vote.store", {
        character: props.character.id,
      }),
      {
        skill_id: skillId,
        eza: props.hasSeza ? 2 : props.hasEza ? 1 : 0,
      },
    )
    .then(() => {
      Swal.fire({
        title: "Success",
        text: "You have voted for your prioritized skill.",
        icon: "success",
        toast: true,
        position: "bottom",
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
    })
    .catch(() => {
      Swal.fire({
        title: "Oops!",
        text: "An error occurred while voting.",
        icon: "error",
        toast: true,
        position: "bottom",
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
    });
}
</script>

<template>
  <BaseCard>
    <template #heading>Skill Voting</template>

    Which Hidden Potential Skill do you prioritize for this character?

    <div class="grid grid-cols-3 gap-4">
      <CharacterSkillVotingSkill
        :active="skillVotes.user === 1"
        :skill-id="1"
        :total-votes="skillVotes.total"
        :votes="skillVotes[1]"
        @click="vote(1)"
      />
      <CharacterSkillVotingSkill
        :active="skillVotes.user === 2"
        :skill-id="2"
        :total-votes="skillVotes.total"
        :votes="skillVotes[2]"
        @click="vote(2)"
      />
      <CharacterSkillVotingSkill
        :active="skillVotes.user === 3"
        :skill-id="3"
        :total-votes="skillVotes.total"
        :votes="skillVotes[3]"
        @click="vote(3)"
      />
    </div>

    <template #footer>
      <span class="self-end"
        >Total votes:
        <span class="font-bold text-green-200">{{
          skillVotes.total
        }}</span></span
      >
    </template>
  </BaseCard>
</template>

<style scoped></style>
